import { render, staticRenderFns } from "./PersonalAssetApplication.vue?vue&type=template&id=74655a5b&scoped=true"
import script from "./PersonalAssetApplication.vue?vue&type=script&lang=js"
export * from "./PersonalAssetApplication.vue?vue&type=script&lang=js"
import style0 from "./PersonalAssetApplication.vue?vue&type=style&index=0&id=74655a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74655a5b",
  null
  
)

export default component.exports